import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { map, Observable } from 'rxjs';
import { PagingResponse } from '@models/paging-response.model';
import { ODataRequest } from '../utilities/sdk-base/o-data-request';
import { DocResource } from '../models/resource/doc.resource';
import { Document } from '../models/ui/document.model';
import { DocResourceToDocumentMapper } from '../models/mappers/doc-resource-to-document.mapper';
import { Collection } from '../models/ui/collection.model';
import { NearDupTextGrouping } from '../models/ui/near-dup-text-grouping.model';
import { NearDupTextGroupingResourceToNearDupTextGroupingMapper } from '../models/mappers/near-dup-text-grouping-resource-to-near-dup-text-grouping.mapper';
import { NearDupTextGroupingResource } from '../models/resource/near-dup-text-grouping.resource';

@Injectable({
	providedIn: 'root'
})
export class DocSdk extends SdkBase {
	constructor(injector: Injector) {
		super(injector);
	}

	public search(params?: GetDocParams): Observable<Collection<Document>> {
		const request = new ODataRequest(`get`, 'docs/search');
		request.requestParams = request.requestParams.set('$search', params.searchTerm);
		request.$top(params?.top ?? 200);
		request.$count();

		return this.makeODataRequest$<PagingResponse<DocResource>>(request, 'api2').pipe(
			map((response) => {
				const mapper = new DocResourceToDocumentMapper();
				return new Collection<Document>({
					items: mapper.mapCollection(response.value),
					totalItems: response['count']
				});
			})
		);
	}

	public getNearDupTextGroupings(index, pageSize): Observable<Collection<NearDupTextGrouping>> {
		const request = new ODataRequest(`get`, `docs/textGroups`);
		if (pageSize > 0)
			request.$top(pageSize).$skip(index * pageSize);

		return this.makeODataRequest$<PagingResponse<NearDupTextGroupingResource>>(request, 'api2').pipe(
			map((response) => {
				const mapper = new NearDupTextGroupingResourceToNearDupTextGroupingMapper();
				return new Collection<NearDupTextGrouping>({
					items: mapper.mapCollection(response.value),
					totalItems: response['count']
				});
			})
		);
	}
}


interface GetDocParams {
	searchTerm?: string;
	top?: number;
}
